import {
  authFetcher,
  fetchWithAuth,
  REPORT_URL,
  resolvePayload,
} from "./const.routes";
import { ReportPostType, ReportPutType, ReportType } from "../types/Report";
import useSWR from "swr";
import { parseError } from "../types/Error/Errors.ts";
import { err } from "../types/Result.ts";

export function useReports(fallback: string[]) {
  const { data, error, isLoading } = useSWR<string[], Error>(
    `${REPORT_URL}all`,
    authFetcher,
  );
  return {
    reports: data ?? fallback,
    isLoading,
    isError: error,
  };
}

export function useUserReports(fallback: string[]) {
  const { data, error, isLoading } = useSWR<string[], Error>(
    `${REPORT_URL}user`,
    authFetcher,
  );
  return {
    reports: data ?? fallback,
    isLoading,
    isError: error,
  };
}

export function useReport(id: string, fallback: ReportType) {
  const { data, error, isLoading } = useSWR<ReportType, Error>(
    `${REPORT_URL}${id}`,
    authFetcher,
  );
  return {
    report: data ?? fallback,
    isLoading,
    isError: error,
  };
}

export async function postReport(report: ReportPostType) {
  try {
    const response = await fetchWithAuth(REPORT_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(report),
    });
    if (response.ok) {
      const report = await response.json();
      return { ok: true, value: report };
    } else {
      return {
        ok: false,
        error: "Uploading Product failed: " + response.statusText,
      };
    }
  } catch (e) {
    return { ok: false, error: "Uploading Product fauled unexpected: " + e };
  }
}

export async function putReport(report: ReportPutType) {
  try {
    const response = await fetchWithAuth(REPORT_URL, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(report),
    });
    return await resolvePayload(response);
  } catch (e) {
    return err(parseError(e));
  }
}
